const finalPrice = product => {
  if (product.special_price > 0 && product.special_price < product.price) {
    return product.special_price
  }
  return product.price
}

module.exports = { finalPrice } 
